/* eslint-disable max-len */
import * as R from 'ramda';
import angular from 'angular';

export default function AddFunctionVendorDialogController(
  $scope,
  ssDialogService,
  loaderService,
  alerts,
  emDataService,
  vmSharedModelService,
  addVendorProductDialog,
  emSharedModelService
) {
  const vm = this;

  vm.newVendor = {
    ...vm.vendor,
    functionProducts: (vm.vendor.functionProducts && vm.vendor.functionProducts.length > 0) ? vm.vendor.functionProducts.map(obj => ({ ...obj })) : [],
  };
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = _handleSubmit;
  vm.handleAddProduct = handleAddProduct;
  vm.handleDeletedProduct = _handleDeletedProduct;

  _activate();


  /** *****************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function _handleSubmit() {
    if ($scope.emAddFunctionVendorForm.$invalid) {
      return Promise.resolve();
    }

    if ((vm.newVendor.name === null) || (vm.newVendor.name === '')) {
      return Promise.resolve();
    }

    const isNew = vm.newVendor.vendorId < 0;

    // if (!isNew && angular.equals(vm.vendor, vm.newVendor)) {
    //   // No need to save
    //   return _closeDialog(); // or return Promise.resolve();
    // }
    loaderService.showViewLoader = true;
    vm.newVendor.functionProducts = _getFormSelections();

    return emDataService.updateVendor(vm.newVendor.functionVendorId, vm.newVendor)
      .then((savedVendor) => {
        angular.extend(vm.newVendor, savedVendor.data);
        if (!vm.newVendor.functionVendorId && savedVendor.data.products.length > 0) {
          vm.newVendor.functionProducts = [];
          angular.forEach(savedVendor.data.products, (product) => {
            const _product = {
              productId: product.productId,
              name: product.name,
              vendorId: product.name,
              canEditProduct: product.canEditProduct,
              canDeleteProduct: product.canDeleteProduct,
            };
            vm.newVendor.functionProducts.push(_product);
          });
        }
        angular.extend(vm.vendor, vm.newVendor);
        if (isNew && vm.addCallback) {
          vm.addCallback(vm.vendor);
        }
        return _closeDialog().then(() => {
          alerts.success('The vendor has been saved successfully.');
        });
      })
      .catch(() => {
        alerts.error('An error occurred while saving the Vendor.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *****************************************
   * Private Functions
   */

  function _activate() {
    const isNew = vm.vendor.vendorId < 0;

    if (isNew) {
      vm.title = 'Add Vendor';
    } else {
      vm.title = 'Edit Vendor';
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.addFunctionVendorDialog);
  }

  function handleAddProduct($event) {
    _showEditProductDialog($event);
  }

  function _handleDeletedProduct(functionObj) {
    if (!functionObj) return;
    const pos = vm.newVendor.functionProducts.indexOf(functionObj);
    if (pos === -1) return; // Can't find the item
    vm.newVendor.functionProducts.splice(pos, 1);
  }

  function _showEditProductDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.editProductDialog = ssDialogService.alert(
      addVendorProductDialog.getOptions($event, {
        product: emSharedModelService.createNewProduct({ vendorId: vm.newVendor.vendorId }),
        vendorId: vm.newVendor.vendorId,
        addCallback: _handleAddedProduct,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProductDialog);
  }

  function _handleAddedProduct(newProduct) {
    newProduct.isSelected = true;
    vm.newVendor.functionProducts = vm.newVendor.functionProducts || [];
    vm.newVendor.functionProducts.push(newProduct);
    if (vm.newVendor.functionProducts && vm.newVendor.functionProducts.length > 1) {
      vm.newVendor.functionProducts = vmSharedModelService.sortByName(vm.newVendor.functionProducts);
    }
  }

  function _getFormSelections() {
    const selectedProducts = [];
    R.forEach((item) => {
      if (item.isSelected) {
        selectedProducts.push(item);
      }
    }, vm.newVendor.functionProducts);
    return selectedProducts;
  }
}

AddFunctionVendorDialogController.$inject = [
  '$scope',
  'ssDialogService',
  'loaderService',
  'alerts',
  'emDataService',
  'vmSharedModelService',
  'addVendorProductDialog',
  'emSharedModelService'
];
